import { DateWithTimezones } from '../../../../common/models/status-history-chain.model';
import { TransportMode } from '../../../../common/constants/transport-mode';
import { ShipmentDeviationType, ShipmentTransportOrderTransitTime } from '../../../models';

export class ShipmentTransportOrderOverview {
  reference: string;
  transportModes: TransportMode[];
  serviceRequirementCodes: string[];
  carrier: string;
  shipmentCreated: DateWithTimezones;
  transportReceipt: DateWithTimezones;
  transitTime: ShipmentTransportOrderTransitTime;
  transportServicePriorityCodes: string[];
  deliveryNoteNumbers: string[];
  invoiceNumbers: string[];
  proNumber: string;
  deviationStatus: ShipmentDeviationType;
}
